import { Button, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IsolatedElementsButtonProps {
  numIsolatedElements: number;
  onClearIsolated: () => void;
}

export default function IsolatedElementsButton({
  numIsolatedElements,
  onClearIsolated,
}: IsolatedElementsButtonProps) {
  const { t } = useTranslation('project');
  const activeIconColor = useColorModeValue('teal.500', 'teal.200');

  if (numIsolatedElements === 0) {
    return null;
  }

  return (
    <Tooltip label={t('viewer-interactions.clear-isolated')}>
      <Button
        colorScheme="teal"
        variant="toggle"
        isActive
        size="xs"
        color={activeIconColor}
        onClick={onClearIsolated}
      >
        {t('viewer-interactions.isolated-elements', {
          numIsolatedElements,
        })}
      </Button>
    </Tooltip>
  );
}
